import cloneDeep from 'lodash/cloneDeep';
import type { SplitTestConfig } from '../splitTestTypes';
import type { AppRemoteConfig } from '../../platform/Platform';

let hs929distribution: number | null = null;

export const hs929interstitials: SplitTestConfig = {
  distributions: 2,
  returningUserTestSlug: 'Interstitials_RU_HS929',
  newUserTestSlug: 'Interstitials_NU_HS929',
  onActive(_, distribution) {
    hs929distribution = distribution;
  },
};

export function hs929overrideInterstitialConfig(config: AppRemoteConfig): AppRemoteConfig {
  if (hs929distribution !== 2) return config;
  const out = cloneDeep(config);
  out.ads.interstitials.useFacebookFlowForInterstitials = false;
  return out;
}
